<template>
    <form class="shaded mx-4 my-4" @submit.prevent.stop="next" novalidate>
        <div v-if="isDisabled" class="form-error-msg">
            <span class="error">* You need to review the mandatory fields before you can save.</span>
        </div>

        <div v-if="!getSelectedPerson" class="d-flex justify-content-end align-items-center my-1 py-2">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <input type="submit" class="btn blue wider" value="Next" :disabled="$v.form.$invalid || $v.businessTypeId.$invalid">
        </div>

        <div class="form-group row mb-0">
            <div class="col-sm-7" v-if="showExistingAgentSelector">
                    <agent-existing-selector @valueChanged="useExistingOrCreateChanged" v-model="form.saveAndSend"></agent-existing-selector>
            </div>

            <div class="col-sm-7" v-else-if="!this.getSelectedPerson">
                    <agent-virtual-or-invite @agentType="agentType" v-model="form.saveAndSend"></agent-virtual-or-invite>
            </div>
        </div>

        <div v-if="passedForm.isOTA" class="lightest bg-medium text-center fs-large p-2 mb-4 bold">
            OTA
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <div class="shaded" :class="getSelectedPerson ? '' : 'panel'">
                    <div class="form-group row mb-1">
                        <div class="col-sm-12" v-if="getSelectedPerson">
                            <h5 class="d-flex justify-content-between align-items-center">
                                <span>Profile</span>

                                <div v-if="form.isLoading" class="d-flex justify-content-right align-items-center position-relative">
                                    <loader></loader>
                                </div>

                                <div v-else-if="!passedForm.isOTA" class="d-flex justify-content-right align-items-center position-relative">
                                    <button v-if="passedForm.inviteStatus == 5" class="btn blue mr-2" @click="callInviteAgent(passedForm)">Connect</button>
                                    <span v-tooltip="disabledForInviteOfflineAgent && 'You need to provide a valid e-mail. Ex: \'user@domain.com\'  '" v-if="passedForm.inviteStatus == 0">
                                        <button :disabled="disabledForInviteOfflineAgent" class="btn blue mr-2" @click="callInviteAgent(passedForm)">Invite</button>
                                    </span>
                                    <span v-else class="btn cursor-default radius-stadium" :class="peopleInviteStatus(passedForm).colorClass">{{peopleInviteStatus(passedForm).label}}</span>
                                    <three-dots v-if="listActions.length > 0" @input="selectedConnectionAction" :items="listActions"></three-dots>
                                </div>
                            </h5>
                        </div>

                        <div class="col-sm-6 input-min-height">
                            <div v-if="useExistingAgent" class="full">
                                <label class="m-0">Name <span class="color-6">*</span></label>

                                <v-select
                                    :options="availableAgents"
                                    label="brandName"
                                    v-model="existingSelectedAgent"
                                    placeholder="Select an agent"
                                    @input="agentSelected">
                                </v-select>
                            </div>

                            <label v-else class="full">
                                Name <span class="color-6">*</span>
                                <input type="text" :disabled="passedForm.isOTA" v-model="form.brandName">
                            </label>

                            <div v-if="$v.form.brandName.$invalid" class="error">
                                <span v-if="!$v.form.brandName.required">Name is required.</span>
                                <span v-if="!$v.form.brandName.minLength">Name must have at least 2 characters.</span>
                            </div>
                        </div>

                        <div class="col-sm-6 input-min-height">
                            <label class="full">
                                Code
                                <input type="text" v-model="form.code">
                            </label>
                        </div>
                    </div>

                    <div class="form-group row mb-1">
                        <div class="col-sm-6 input-min-height">
                            <label class="full">
                                Email <span class="color-6">*</span>
                                <input type="text" v-model.trim="form.email" :disabled="disableEditEmail" @keyup="emailChanged = true">
                            </label>

                            <div v-if="$v.form.email.$invalid" class="error">
                                <span v-if="!$v.form.email.required">Email is required.</span>
                                <span v-if="!$v.form.email.email">Must be a valid email.</span>
                            </div>
                        </div>

                        <div class="col-sm-6 input-min-height">
                            <label class="full">
                                Phone
                                <input type="text" v-model="form.phone">
                            </label>

                            <div v-if="$v.form.phone.$invalid" class="error">
                                <span>This must be a phone number.</span>
                            </div>
                        </div>

						<div class="col-sm-12 mb-1 input-min-height">
							<div class="row">
								<div v-if="getChannelSalesList && !passedForm.isOTA" class="col-sm-6">
									<label>Business Type</label>

									<v-select
										v-model="selectedRole"
										:options="getChannelSalesList"
										placeholder="Pick a sales channel"
										label="description"
										@input="updateRole">
									</v-select>
								</div>

								<div v-if="selectedRole && selectedRole.id === 100" class="col-sm-6 input-min-height">
									<label>
										Custom Business Type <span v-if="isRequiredToChooseCustomBusinessType" class="color-6">*</span>
									</label>

									<v-select
										v-if="getCustomBusinessTypes.length > 0"
										v-model="form.businessType"
										:options="getCustomBusinessTypes"
										placeholder="Select a custom business type"
										label="name"
										@input="customBusinessTypeChanged($event)">
									</v-select>

									<!-- If no custom business types, add if the user has permission -->
									<button v-if="getCustomBusinessTypes.length === 0" class="btn btn-xs mt-1" @click="addCustomBusinessType">Add Custom Business Type</button>
									
                                    <div v-if="$v.businessTypeId.$invalid" class="error">
										<span>You must {{ getCustomBusinessTypes.length > 0 ? 'select' : 'add' }} a custom business type.</span>
									</div>
								</div>
							</div>
						</div>

                        <div class="col-sm-12 mb-5" v-if="!passedForm.isOTA">
                            <label class="full">
                                Notes <span class="normal">(internal note)</span>
                                <textarea v-model="form.note"></textarea>
                            </label>
                        </div>

                    </div>

                    <div class="mb-5" v-if="!passedForm.isOTA">
                        <h5>Contacts</h5>

                        <div class="form-group row">
                            <div class="col-sm-6">
                                <label class="full">
                                    Financial Email
                                    <input type="text" v-model="form.contactFinancialEmail">
                                </label>
                            </div>

                            <div class="col-sm-6">
                                <label class="full">
                                    Financial Phone
                                    <input type="text" v-model="form.contactFinancialPhone">
                                </label>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-6">
                                <label class="full">
                                    Sales Email
                                    <input type="text" v-model="form.contactSalesEmail">
                                </label>
                            </div>

                            <div class="col-sm-6">
                                <label class="full">
                                    Sales Phone
                                    <input type="text" v-model="form.contactSalesPhone">
                                </label>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-6">
                                <label class="full">
                                    General Email
                                    <input type="text" v-model="form.contactOthersEmail">
                                </label>
                            </div>

                            <div class="col-sm-6">
                                <label class="full">
                                    General Phone
                                    <input type="text" v-model="form.contactOthersPhone">
                                </label>
                            </div>
                        </div>

                    </div>

                    <h5>Billing Details</h5>

                    <div class="form-group row mb-1">
                        <div class="col-sm-6 input-min-height">
                            <label class="full">
                                Billing name <span class="color-6">*</span>
                                <input type="text" v-model="form.name">
                            </label>

                            <div v-if="$v.form.name.$invalid" class="error">
                                <span v-if="!$v.form.name.required">Billing name is required.</span>
                                <span v-if="!$v.form.name.minLength">Billing name must have at least 3 characters.</span>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <label class="full d-flex align-items-center mb-0">
                                <span>VAT number</span>
                                <i v-if="getHasInvoiceSystem && !form.vat" class="fas fa-exclamation-triangle color-4 fs-smallest ml-1" v-tooltip="'Required to create invoices'"></i>
                            </label>

                            <input class="w-100" type="text" v-model="form.vat">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-12 mb-2">
                            <label class="full d-flex align-items-center">
                                <span>Address</span>
                                <i v-if="getHasInvoiceSystem && !form.address" class="fas fa-exclamation-triangle color-4 fs-smallest ml-1" v-tooltip="'Required to create invoices'"></i>
                            </label>

                            <textarea class="w-100" v-model="form.address"></textarea>
                        </div>
                    </div>

                    <div class="form-group row mb-5">
                        <div class="col-sm-4">
                            <label class="full">ZIP Code
                                <input type="text" v-model="form.zip">
                            </label>
                        </div>

                        <div class="col-sm-4">
                            <label class="full">Location
                                <input type="text" v-model="form.location">
                            </label>
                        </div>

                        <div class="col-sm-4">
                            <label class="full mb-0">Country</label>
                        
                            <country-picker :openDirection="'bottom'" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event)"></country-picker>
                        </div>
                    </div>

                    <h5 v-if="showFeatureScheduleTasks">Schedule Tasks</h5>
                    
                    <div v-if="showFeatureScheduleTasks" class="form-group row">
                        <div class="col-sm-6">
                            <checkbox v-model="form.isWorkflowAllowedToSendEmails">
                                Allow sending automatic emails
                            </checkbox>
                        </div>
                    </div>

                    <h5 class="mt-4">Reports</h5>

                    <div class="form-group row">
                        <div class="col-sm-6">
                            <checkbox v-model="form.isToHideReportCalculations">
                                Hide page that explains all the calculations.
                            </checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!getSelectedPerson" class="d-flex justify-content-end align-items-center my-1 p-2">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <input type="submit" class="btn blue wider" value="Next" :disabled="$v.form.$invalid || $v.businessTypeId.$invalid">
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import { peopleMixin } from '@/mixins/people'

    import AgentExistingSelector from './AgentExistingSelector'
    import AgentVirtualOrInvite from './AgentNewSelector'
    import extendedVSelect from '@/extends/vue-select'
    import threeDots from '@/tools/threeDots'
    import Loader from '@/tools/loaders/loader1'
    import CountryPicker from '@/tools/CountryPicker'

    export default {
        data() {
            return {
                useExistingAgent: false,
                selectedAgent: null,
                form: {
                    saveAndSend: true,
                    name: '',
                    brandName: '',
                    address: '',
                    contactFinancialEmail: '',
                    contactFinancialPhone: '',
                    contactSalesEmail: '',
                    contactSalesPhone: '',
                    contactOthersEmail: '',
                    contactOthersPhone: '',
                    note: '',
                    country: null,
                    vat: '',
                    zip: '',
                    place: '',
                    transportation: {},
                    contacts: [],
                    email: '',
                    phone: '',
                    role: null,
                    payment: 1,
                    deposit: null,
                    imageLogo: null,
                    imageLogoBase64: null,
                    locationMain: null,
                    agentSize: null,
                    salesChannel: null,
                    bookPermission: false,
                    DepositCurrency: "€",
                    SalesStore: false,
                    SalesWebsite: false,
                    SalesHotel: false,
                    currency: "€",
                    timezone: null,
                    slogan: "",
            		website: "",
            		facebook: "",
            		twitter: "",
            		pluraloUrl: "",
                    businessType: null,
                },
                businessTypeId: null,
                selectedRole: null,
                selectedPayment: null,
                selectedDeposit: null,
                originalSelectedAgent: {},
                existingSelectedAgent: null,
                emailChanged: false,
                agentTypeIs: "offlineAgent",
                defaultCountry: null,
                selectedCountry: null,
            }
        },
        props: {
            passedForm: {
                default: null
            },
            showExistingAgentSelector: {
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            isEditAgent: {
                default: false
            },
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
                email: {
                    email,
                    required,
                },
                phone: {
                    minLength: minLength(4),
                },
                brandName: {
                    required,
                    minLength: minLength(2),
                }
            },
            businessTypeId: {
                required() {
                    return this.isRequiredToChooseCustomBusinessType ? !!this.form.businessType : true;
                },
            }
        },
        mixins:[
            peopleMixin
        ],
        created() {
            if (this.passedForm) {
                this.form = this.passedForm;
            } else if (this.getSelectedPerson) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedPerson));
            } else {
                for (let k in this.getNewAgentSetup) {
                    this.form[k] = this.getNewAgentSetup[k];
                }
            }

            // Set country if edit agent
            if (this.isEditAgent && this.form.country) {
                this.setCountry();
            }

            // Set correct deposit
            this.setCorrectDeposit();

            // Populate selection
            this.populateChannelSales();

            if (this.form.inviteStatus != 0) {
                this.agentTypeIs = "onlineAgent";
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getNewAgentSetup',
                'getCountries',
                'account',
                'getAgents',
                'getChannelSalesList',
                'getDepositOptions',
                'getRequirePaymentOptions',
                'getHasInvoiceSystem',
				'getCustomBusinessTypes',
            ]),
            showFeatureScheduleTasks() {
                return process.env.FEATURE_SCHEDULETASKS;
            },
			isRequiredToChooseCustomBusinessType() {
				if (this.selectedRole && this.selectedRole.id !== 100) {
					this.form.businessType = null;
                    this.businessTypeId = null;
					
                    return false;
				}
				
                return true;
			},
            disabledForInviteOfflineAgent() {
                const validEmail = this.validEmail(this.form.email);

                if (this.agentTypeIs === 'offlineAgent' && !validEmail) {
                    return true;
                }
                
                return false;
            },
            disableEditEmail() {
                if (this.form.inviteStatus <= 10) {
                    return false;
                } else {
                    return this.getSelectedPerson && this.form.isPhysicalAccountCreated || this.showExistingAgentSelector;
                }
            },
            listActions() {
                let vm = this;
                let action_disconnect = {
                    label: 'Disconnect',
                    toolTip: 'This agent will no longer <br >be able to book online, but <br> your team can book on his <br> behalf.',
                    action: function () {
                        vm.$dialog.confirm(
                            '<h1 class="text-center mb-4">Disconnect '+vm.passedForm.brandName+'?</h1><div class="fs-small"><p class="mb-2">They won\'t be able to see products, availabilities or book your products online but your teammates will continue to book on their behalf in the dashboard.</p><p>Pluralo will not let them know you disconnect them.</p></div>',
                            {
                                okText: 'Disconnect',
                                customClass: 'red'
                            }
                        ).then(function () {
                            vm.form.isLoading = true;
                            vm.disconnectAgent({
                                agentId: vm.passedForm.id
                            }).then(response => {
                                vm.form.isLoading = false;
                                vm.form.protocolStatus = 0;
                                vm.form.inviteStatus = 5;
                                vm.downloadAgents();
                            })
                        })
                        .catch(function () { });
                    }
                }

                let action_connect = {
                    label: 'Connect',
                    toolTip: 'Invite this agent to connect with you',
                    action: function () {
                        vm.form.isLoading = true;
                        vm.connectToAgent({
                            agent: vm.passedForm
                        }).then(response => {
                            vm.form.isLoading = false;
                            vm.downloadAgents();
                        })
                    }
                }

                let action_invite = {
                    label: 'Invite',
                    toolTip: 'Invite this agent to join Pluralo',
                    action: function () {
                        vm.form.isLoading = true;
                        vm.inviteAgent({
                            agent: vm.passedForm
                        }).then(response => {
                            vm.form.isLoading = false;
                            vm.downloadAgents();
                        })
                    }
                }

                let action_resend_invite = {
                    label: 'Resend Invite',
                    toolTip: 'You will resend an email invitation to the agent.',
                    action: function () {
                        if(!vm.validEmail(vm.passedForm.email)) {
                            vm.$dialog.alert(
                            vm.passedForm.email.length > 0
                                ? '<h1 class="text-center mb-4" style="line-height: 1;">You need to provide a valid email before procced</h1><div class="fs-small"><p class="mb-2">Note that we cannot send emails to <strong>'+vm.passedForm.email+'</strong> because this is not a valid email.</p></div>'
                                : '<h1 class="text-center mb-4" style="line-height: 1;">You need to provide a valid email before procced</h1><div class="fs-small"><p class="mb-2">We cannot send emails if you don\'t provide one.</p></div>',
                                {
                                    okText: 'Ok',
                                    customClass: 'red'
                                }
                            )
                        } 
                        else 
                        {
                            vm.$dialog.confirm(
                                '<h1 class="text-center mb-4" style="line-height: 1;">Resend Invite to '+vm.passedForm.email+'?</h1><div class="fs-small"><p class="mb-2">Be aware that if you send successive invitations, your next emails could end up in a spam box.</p></div>',
                                {
                                    okText: 'Resend Invite',
                                    customClass: 'okBlue'
                                }
                            ).then(function () {
                                vm.form.isLoading = true;
                                vm.inviteAgent({
                                agent: vm.passedForm
                                })
                                .then( response => {
                                vm.form.isLoading = false;
                                vm.closeModal();
                                vm.downloadAgents();
                                })
                            })
                            .catch(function () { });
                        }
                    }
                }

                let action_blacklist = {
                    label: 'Send to blacklist',
                    toolTip: 'Both agent and your <br> teammates will be unable <br>to create bookings with <br> this agent as a seller',
                    action: function () {
                        vm.$dialog.confirm(
                            '<h1 class="text-center mb-4">Send '+vm.passedForm.brandName+' to Blacklist?</h1><div class="fs-small"><p class="mb-2">They won\'t be able to see or book your products and teammates will be unable to book on his behalf.</p><p>Pluralo will let them know you block them.</p></div>',
                            {
                                okText: 'Send to Blacklist',
                                customClass: 'red'
                            }
                        ).then(function () {
                            vm.form.isLoading = true
                            vm.suspendAgent({
                                agentId: vm.passedForm.id
                            }).then(response => {
                                vm.form.isLoading = false;
                                vm.form.protocolStatus = 5;
                                vm.downloadAgents();
                            })
                        })
                        .catch(function () { });
                    }
                }

                let action_removeFromBlacklist = {
                    label: 'Remove from Blacklist',
                    toolTip: 'Enable both your team and agent to create bookings',
                    action: function () {
                        vm.$dialog.confirm(
                            '<h1 class="text-center mb-4">Unblock '+vm.passedForm.brandName+'?</h1><div class="fs-small"><p class="mb-2">They will be able to see or book your products and teammates will be able to book on his behalf.</p><p>Pluralo will let them know you unblocked them.</p></div>',
                            {
                                okText: 'Unblock',
                            }
                        ).then(function () {
                            vm.form.isLoading = true;
                            vm.unsuspendAgent({
                                agentId: vm.passedForm.id
                            }).then(response => {
                                vm.form.isLoading = false;
                                vm.form.protocolStatus = 1;
                                vm.downloadAgents();
                            })
                        })
                        .catch(function () { });
                    }
                }

                let actionsArray = [];

                switch (this.passedForm.inviteStatus) {
                    // Connected
                    case 15:
                        if (this.passedForm.protocolStatus == 5 ){
                            actionsArray.push(action_removeFromBlacklist);
                        } else {
                            actionsArray.push(action_disconnect);
                            actionsArray.push(action_blacklist);
                        }
                        
                        break;
                    // Pending
                    case 10:
                        if (this.passedForm.protocolStatus == 5) {
                            actionsArray.push(action_removeFromBlacklist);
                        } else {
                            actionsArray.push(action_blacklist);
                            actionsArray.push(action_resend_invite);
                        }
                        
                        break;
                    // Available
                    case 5:
                        if (this.passedForm.protocolStatus == 5) {
                            actionsArray.push(action_removeFromBlacklist);
                        } else {
                            actionsArray.push(action_blacklist);
                        }
                        
                        break;
                    // Offline
                    case 0:
                        if (this.passedForm.protocolStatus == 5) {
                            actionsArray.push(action_removeFromBlacklist);
                        } else {
                            actionsArray.push(action_blacklist);
                        }
                        
                        break;
                    default:

                }

                return actionsArray;
            },
            availableAgents() {
                let output = this.getAgents.filter(agent => {
                    return agent.inviteStatus != 15;
                })

                return output;
            },
            agentInviteStatus() {
                // 1 = not registered on Pluralod
                // 2 = Pending connection
                // 3 = connected
                if (!this.form.isPhysicalAccountCreated) {
                    // The agent has no account
                    return 1;
                } else {
                    // The agent has an account
                    if (this.form.isPhysicalAccountConnected) {
                        // The supplier and agent are connected
                        return 3;
                    } else {
                        // Agent not connected to supplier
                        return 2;
                    }
                }
            },
            showDepositValue() {
                return this.selectedDeposit && this.selectedDeposit.id != 2;
            },
            deposits() {
                return this.getDepositOptions;
            },
            payments() {
                return this.getRequirePaymentOptions;
            }
        },
        methods: {
            ...mapActions([
                'inviteAgent',
                'connectToAgent',
                'updateNewAgentSetup',
                'updateClonedAgent',
                'closeModal',
                'disconnectAgent',
                'suspendAgent',
                'unsuspendAgent',
                'downloadAgents',
				'openModal',
            ]),
            updateCountry(selectedCountry) {
                let oldCountry = this.form.country;
                this.selectedCountry = selectedCountry;

                if (selectedCountry !== null) {
                    this.form.country = selectedCountry;
                    if (typeof this.form.country === "undefined") {
                        this.form.country = oldCountry;
                    }
                }
            },
			customBusinessTypeChanged(selectedCustomBusinessType){
                this.$set(this.form, 'businessType', selectedCustomBusinessType);
                this.businessTypeId = selectedCustomBusinessType.Id;
			},
            validEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                
                return re.test(email);
            },
            selectedConnectionAction(item) {
                item.action();
            },
            setCorrectDeposit() {
                this.$set(this, 'selectedDeposit', this.getDepositOptions.find( depositOption => {
                        return depositOption.id == this.form.depositType;
                    })
                )

                this.$set(this, 'selectedPayment', this.getRequirePaymentOptions.find(paymentOption => {
                        return paymentOption.id == this.form.payment;
                    })
                )
            },
            clickedActionButton(passedForm) {
                switch (passedForm.inviteStatus) {
                    case 0:
                    case 1:
                    case 2:
                    case 5:
                        this.callInviteAgent(this.form);
                        break;
                    default:
                }
            },
            agentSelected(selectedAgent) {
                this.form = selectedAgent;
                this.form.email = this.getNewAgentSetup.email;
            },
            useExistingOrCreateChanged(val) {
                this.useExistingAgent = val;

                if (this.existingSelectedAgent && val) {
                    this.form = this.existingSelectedAgent;
                    
                    return;
                }
                
                if (val == false) {
                    this.clearAgent();
                } else {
                    this.form = {
                        name: null,
                        brandName: null,
                        address: '',
                        country: null,
                        vat: '',
                        zip: '',
                        place: '',
                        transportation: {},
                        contacts: [],
                        email: '',
                        phone: '',
                        role: null,
                        payment: 1,
                        deposit: null,
                        imageLogo: null,
                        imageLogoBase64: null,
                        locationMain: null,
                        agentSize: null,
                        salesChannel: null,
                        bookPermission: false,
                        DepositCurrency: "€",
                        SalesStore: false,
                        SalesWebsite: false,
                        SalesHotel: false,
                        currency: "€",
                        timezone: null,
                        slogan: "",
                		website: "",
                		facebook: "",
                		twitter: "",
                		pluraloUrl: "",
                        businessType: null,
                    };

                    this.form.email = this.getNewAgentSetup.email;
                }
            },
            clearAgent() {
                this.form = this.getNewAgentSetup;
            },
            callInviteAgent(agent) {
                if (agent.inviteStatus > 5) {
                    this.$toasted.info('Already connected to this agent');
                    
                    return true;
                }

                if (agent.inviteStatus == 0) {
                    this.inviteAgent({
                        supplierId: this.account.supplierId,
                        agent: agent
                    }).then(response => {
                        this.downloadAgents();
                        this.closeModal();
                    })
                } else if (agent.inviteStatus == 5) {
                    this.connectToAgent({
                        supplierId: this.account.supplierId,
                        agent: agent
                    }).then(response => {
                        this.downloadAgents();
                        this.closeModal();
                    })
                }
            },
			addCustomBusinessType(){
				this.openModal('customBusinessTypes/createCustomBusinessType');
			},
            updateRole() {
                if (this.selectedRole) {
					if (this.getCustomBusinessTypes.length === 0 && this.selectedRole.id === 100) {
						this.openModal('customBusinessTypes/createCustomBusinessType');
					}
                    this.form.role = this.selectedRole.id || null;
                }
            },
            addRow() {
                this.form.contacts.push(this.createEmptyRow());
            },
            populateChannelSales() {
                if (this.form.role) {
                    this.selectedRole = this.getChannelSalesList.find(item => item.id === this.form.role);
                } else {
                    this.selectedRole = this.getChannelSalesList[0];
                    this.form.role = this.getChannelSalesList[0].id;
                }
            },
            createEmptyRow() {
                return {
                    type: '',
                    email: '',
                    phone: '',
                    status: 'new',
                };
            },
            formatValue() {
                if (this.form.paymentValue !== undefined) {
                    this.form.depositValue = parseFloat(this.form.paymentValue).toFixed(2);
                }
            },
            updatePayment() {
                this.form.payment = this.selectedPayment.id;
                
                if (this.selectedPayment === this.payments[0]) {
                    this.form.paymentValue = 0;
                }

                this.formatValue();
            },
            cancel() {
                this.$emit('cancelling');
            },
            agentType(agentType) {
                this.agentTypeIs = agentType;
            },
            save() {
                this.$emit('save');
            },
            next() {
                this.updateNewAgentSetup(this.form);
                this.$emit('goToNext', { invalid: this.$v.form.invalid, form: this.form });
            },
            setCountry() {
                this.selectedCountry = this.getCountries.find(c => c.id === this.form.country.id);

                this.form.country = this.selectedCountry;
            }
        },
        components: {
            vSelect: extendedVSelect,
            AgentExistingSelector,
            AgentVirtualOrInvite,
            threeDots,
            Loader,
            CountryPicker
        },
        watch: {
            $v: {
                handler(n, o) {
                    let toggleIsDisabled = n.$invalid ? true : false;

                    this.$emit('toggleIsDisabled', toggleIsDisabled);
                    this.$emit('formHaveErros', toggleIsDisabled );

                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            },
            'getNewAgentSetup': {
                handler(n, o) {
                    this.populateChannelSales();
                },
                deep: true
            },
			'getCustomBusinessTypes': {
				handler(newVal, oldVal) {
					if (newVal.length === 1) {
						this.$set(this.form, 'businessType', newVal[0]);
					}
				}
			}
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .schedule {
        > li {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            padding-top: 1rem;
            border-top: 1px solid $light;

            &:first-child {
                border: 0;
            }
        }
    }

    .add {
        margin-bottom: 3.5rem;
    }

    .form-error-msg {
        margin-bottom: -1.565rem;
    }

    .input-min-height {
        min-height: 5.07rem;
    }
</style>



// WEBPACK FOOTER //
// AgentForm.vue?7fe0a858